<template>
  <div class="creative-spinner-container" :class="[size, { 'inline': inline }]">
    <div class="spinner-box">
      <div class="leo-border-1">
        <div class="leo-core-1"></div>
      </div> 
      <div class="leo-border-2">
        <div class="leo-core-2"></div>
      </div> 
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreativeSpinner',
  props: {
    size: {
      type: String, // 'sm', 'md', 'lg'
      default: 'md'
    },
    inline: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.creative-spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.creative-spinner-container.inline {
  display: inline-flex;
  vertical-align: middle;
}

.spinner-box {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}

/* Sizes */
.sm .spinner-box { width: 20px; height: 20px; }
.md .spinner-box { width: 60px; height: 60px; }
.lg .spinner-box { width: 100px; height: 100px; }

/* Spinner Design */
.leo-border-1 {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background:rgb(63, 249, 220);
  background: linear-gradient(0deg, rgba(63,249,220,0.1) 33%, rgba(63,249,220,1) 100%);
  animation: spin3D 1.8s linear 0s infinite;
}

.leo-core-1 {
  width: 100%;
  height: 100%;
  background-color: transparent; /* center hole */
  border-radius: 50%;
}

.leo-border-2 {
  position: absolute;
  width: 70%;
  height: 70%;
  padding: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: rgb(251, 91, 83);
  background: linear-gradient(0deg, rgba(251, 91, 83, 0.1) 33%, rgba(251, 91, 83, 1) 100%);
  animation: spin3D 2.2s linear 0s infinite;
}

.leo-core-2 {
  width: 100%;
  height: 100%;
  background-color: transparent;
  border-radius: 50%;
}

/* Sidebar Specific Colors (Overrides) */
/* Assuming Sidebar is Dark Blue/Purple */
.creative-spinner-container .leo-border-1 {
  background: linear-gradient(0deg, rgba(64, 158, 255, 0.1) 33%, #409eff 100%); /* Element Blue */
}

.creative-spinner-container .leo-border-2 {
  background: linear-gradient(0deg, rgba(48, 65, 86, 0.1) 33%, #304156 100%); /* Sidebar Dark */
}

@keyframes spin3D {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>
